document.addEventListener('DOMContentLoaded', () => {
  if (typeof subscribe === 'undefined' || typeof PUB_SUB_EVENTS === 'undefined') return;

  const productSection = document.querySelector('[data-product-section]');
  if (!productSection) return;

  const productId = productSection.dataset.productId;
  const variantSelector = productSection.querySelector('variant-selector');
  if (!variantSelector) return;
  // Scoped: product-form elsewhere on the page (cart drawer cards) also carries data-product-price.
  const priceDisplay = productSection.querySelector('[data-product-price-display]');
  const priceEl = priceDisplay?.querySelector('[data-product-price]');
  const comparePriceEl = priceDisplay?.querySelector('[data-product-compare-price]');
  const discountEl = priceDisplay?.querySelector('[data-product-discount]');
  const priceDividerEl = priceDisplay?.querySelector('[data-product-price-divider]');

  const updatePrice = (variant) => {
    if (!priceEl) return;

    priceEl.textContent = variant.price_formatted;

    const onSale = variant.compare_at_price > variant.price;

    if (comparePriceEl) {
      if (onSale) {
        comparePriceEl.textContent = variant.compare_at_price_formatted;
        comparePriceEl.classList.remove('hidden');
      } else {
        comparePriceEl.classList.add('hidden');
      }
    }

    if (discountEl) {
      if (onSale) {
        const discount = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
        const template = window.theme?.strings?.savePercent ?? 'Save {{ percent }}%';
        discountEl.textContent = template.replace('{{ percent }}', discount);
        discountEl.classList.remove('hidden');
      } else {
        discountEl.classList.add('hidden');
      }
    }

    priceDividerEl?.classList.toggle('hidden', !onSale);
  };

  const updateURL = (variant) => {
    const url = new URL(window.location);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url);
  };

  // Every image stays in the gallery; the selected variant's image leads, as on the live theme.
  const showVariantMedia = (variant) => {
    if (!variant.featured_media_id) return;

    const gallery = document.querySelector('product-gallery');
    gallery?.showHeroMedia(variant.featured_media_id);
    gallery?.scrollToMediaId(variant.featured_media_id);
  };

  subscribe(PUB_SUB_EVENTS.variantChange, (data) => {
    if (data.productId !== productId) return;

    if (!data.variant) {
      if (discountEl) discountEl.classList.add('hidden');
      return;
    }

    updatePrice(data.variant);
    updateURL(data.variant);
    showVariantMedia(data.variant);
  });

  // Hidden large tiles are lazy; start loading the one an option would show as soon as it's pointed at.
  const preloadOptionMedia = (event) => {
    const button = event.target.closest?.('[data-option-value]');
    if (!button) return;

    const index = Number(button.dataset.optionIndex);
    const selected = variantSelector.selectedOptions ?? [];
    const matches = (v) =>
      v.options[index] === button.dataset.optionValue &&
      v.options.slice(0, index).every((opt, i) => opt === selected[i]);
    const candidates = (variantSelector.variants ?? []).filter(matches);
    const variant =
      candidates.find((v) => v.options.every((opt, i) => i === index || opt === selected[i])) ?? candidates[0];
    if (variant?.featured_media_id)
      document.querySelector('product-gallery')?.preloadHeroMedia(variant.featured_media_id);
  };
  variantSelector.addEventListener('pointerover', preloadOptionMedia);
  variantSelector.addEventListener('focusin', preloadOptionMedia);

  // A ?variant= link opens on that variant's image; the desktop tile is already server-rendered.
  if (new URL(window.location).searchParams.has('variant')) {
    const initialVariant = variantSelector.variants?.find((v) =>
      v.options.every((opt, i) => opt === variantSelector.selectedOptions?.[i]),
    );
    if (initialVariant?.featured_media_id) {
      document.querySelector('product-gallery')?.scrollToMediaId(initialVariant.featured_media_id);
    }
  }
});
